import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { uiClientsConfig } from 'admin-ui-v2-config';

@Injectable({
  providedIn: 'root',
})
export class SystemDesignGuard implements CanActivate {
  constructor( private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const { customerUrlPrefix } =uiClientsConfig;
    if (customerUrlPrefix !== 'local') {
      return this.router.parseUrl('/');
    }
    return  true ;
  }
}
